__turbopack_context__.v({
  "img": "research-module-scss-module__wrqd6W__img",
  "input-container": "research-module-scss-module__wrqd6W__input-container",
  "wrap": "research-module-scss-module__wrqd6W__wrap",
});
